import { Fragment } from 'react'
import { InputLabel, AutoExpandTextArea, WithTheme } from '@opallabs/lapidary'
import * as styles from '../styles'

export type GenerateContentProps = WithTheme & {
  label: string
  onChange: (value: string) => void
  placeholder: string
}

export const GenerateContentInput: React.FC<GenerateContentProps> = ({
  label,
  onChange,
  placeholder,
  theme = 'dark',
}) => {
  return (
    <Fragment>
      <InputLabel
        required={false}
        text={label}
        theme={theme}
        styleOverrides={styles.labelOverrides}
      />
      <AutoExpandTextArea
        placeholder={placeholder}
        onChange={(textarea: any): void => onChange(textarea.target.value)}
        theme={theme}
        minRows={4}
        maxRows={6}
        required={false}
        styleOverrides={styles.textAreaOverrides}
      />
    </Fragment>
  )
}
